import React from "react";
import { View } from "@/styles/reactnative";
import MarketTrendHeader from "../MarketTrendHeader";
import CryptoPrice from "./CryptoPrice";
import CryptoVolume from "./CryptoVolume";

const CryptoCurrencyVolatillity = () => {
  return (
    <View style={{ alignItems: "flex-start" }}>
      <MarketTrendHeader title={"cryptocurrencyMarketVolatility"} />
      <CryptoPrice />
      <CryptoVolume />
    </View>
  );
};

export default React.memo(CryptoCurrencyVolatillity);
